<div fxLayout="row" fxLayoutAlign="center">
  <div fxFlex="60%" fxFlex.xs="100%" fxFlex.sm="80%">
    <div class="container-404">
      <h1 style="color: red" class="mat-headline-1">404</h1>
      <p>
        Error 404 | We can't seem to find the page you're looking for.
        Go to our <a routerLink="/">home page</a> or go back to <a (click)="back()">previous page</a>.
      </p>
    </div>
  </div>
</div>
